<app-topnav></app-topnav>


<div class="top-main-wrapper">

    <div class="dash-header">
        <div class="dash-title">

            <div class="p-field p-grid">
                <div class="p-col-6 p-md-6">
                    <h3>Dashboard</h3>
                </div>
                <div class="p-col-6 p-md-6">

                </div>

            </div>
        </div>
    </div>
</div>

<div class="main-inner">






    <div class="p-grid">

        <div class="p-col-12 p-md-12">

            <div class="p-grid">

                <div class="p-col-12 p-md-7">
                    <div class="p-grid">

                        <div class="p-col-6 p-md-6 p-lg-3">

                            <p-card class="number-card" [routerLink]="['/admin/likes']">

                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="icon-container">
                                            <i tooltipposition="right" class="pi pi-heart"></i>
                                        </div>

                                    </div>
                                    <div class="p-col-12 p-md-12">
                                        <h3 class="mb-0 p-pb-0"> {{countLikes}}</h3>
                                        <p class="p-pt-0">Likes</p>


                                    </div>


                                </div>
                            </p-card>
                        </div>

                        <div class="p-col-6 p-md-6 p-lg-3">

                            <p-card class="number-card" [routerLink]="['/admin/startups']">

                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="icon-container">
                                            <i tooltipposition="right" class="pi pi-list"></i>
                                        </div>

                                    </div>
                                    <div class="p-col-12 p-md-12">
                                        <h3 class="mb-0 p-pb-0"> {{countStartups}}</h3>
                                        <p class="p-pt-0">Startups</p>


                                    </div>


                                </div>
                            </p-card>
                        </div>

                        <div class="p-col-6 p-md-6 p-lg-3">

                            <p-card class="number-card" [routerLink]="['/admin/users']">

                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="icon-container">
                                            <i tooltipposition="right" class="pi pi-user"></i>
                                        </div>

                                    </div>
                                    <div class="p-col-12 p-md-12">
                                        <h3 class="mb-0 p-pb-0"> {{countClients}}</h3>
                                        <p class="p-pt-0">Users</p>


                                    </div>


                                </div>
                            </p-card>
                        </div>
                        <div class="p-col-6 p-md-6 p-lg-3">

                            <p-card class="number-card" [routerLink]="['/admin/reviews']">

                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="icon-container">
                                            <i tooltipposition="right" class="pi pi-comment"></i>
                                        </div>

                                    </div>
                                    <div class="p-col-12 p-md-12">
                                        <h3 class="mb-0 p-pb-0"> {{countReviews}}</h3>
                                        <p class="p-pt-0">Reviews</p>


                                    </div>


                                </div>
                            </p-card>
                        </div>
                    </div>
                    <div class="p-grid">

                        <div class="p-col-12 p-md-12">

                            <h3>Last Startups</h3>

                        </div>
                    </div>

                    <div class="p-grid">

                        <div class="p-col-12 p-md-12 featured-card">
                            <p-table #dt [columns]="cols" [value]="startups" [rows]="10" [paginator]="false">

                                <ng-template pTemplate="body" let-startup let-columns="columns">
                                    <tr>
                                        <td width="60">
                                            <img class="img-responsive"
                                                [routerLink]="['/admin/startups/edit', startup.id]"
                                                [src]="'https://api.startupinspire.com/assets/startups/' + startup.id + '/' + startup.startup_logo">

                                        </td>

                                        <td>
                                            <h4 class="p-mb-0 p-mt-0">{{startup.startup_name}}</h4>
                                            <p class="small">{{startup.country}} |
                                                {{startup.startup_email}}</p>
                                        </td>
                                        <td>
                                            <div *ngIf="startup.status == 1" class="dot-green p-mb-10"></div>
                                            <div *ngIf="startup.status == 0" class="dot-red"></div>

                                        </td>

                                        <td>
                                            <ng-container *ngIf="domainRatings[startup.id] as dr">
                                                <span *ngIf="dr.loading" class="pi pi-spin pi-spinner"></span>
                                                <div *ngIf="!dr.loading && dr.rating !== undefined && dr.rating !== null"
                                                    style="position: relative; width: 44px; height: 44px; display: inline-block;">
                                                    <div [style.width.px]="44" [style.height.px]="44"
                                                        [style.border-radius]="'50%'"
                                                        [style.background]="getDomainRankGaugeBackground(dr.rating)"
                                                        [style.-webkit-mask]="'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))'"
                                                        [style.mask]="'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))'">
                                                    </div>
                                                    <span
                                                        style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; color: #333;">{{dr.rating}}</span>
                                                </div>
                                                <p-tag *ngIf="!dr.loading && dr.error" severity="danger"
                                                    value="N/A"></p-tag>
                                            </ng-container>
                                        </td>



                                        <td class="action">


                                            <button pButton pRipple label="edit" icon="pi pi-eye"
                                                class="p-button p-button-primary pull-right p-mr-2"
                                                [routerLink]="['/admin/startups/edit', startup.id]"></button>

                                            <button type="button" pButton pRipple label="website"
                                                class="p-button p-button-outline pull-right  p-mr-2"
                                                (click)="goToUrl(startup.startup_url)"></button>





                                            <!--  <button pButton pRipple icon="pi pi-trash"
                                        class="p-button p-button-danger pull-right p-mr-2"
                                        (click)="onDelete(startup.id)"></button>
    
                                    <button pButton pRipple icon="pi pi-eye"
                                        class="p-button p-button-primary pull-right p-mr-2"
                                        (click)="edit(startup)"></button>
                                    <button pButton pRipple icon="pi pi-pencil"
                                        class="p-button p-button-success pull-right  p-mr-2"
                                        [routerLink]="['/admin/startups/edit', startup.id]"></button> -->
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                    </div>
                </div>

                <div class="p-col-12 p-md-5">

                    <p-card class="table-list">
                        <ng-template pTemplate="header">
                            <div class="p-p-3 p-d-flex p-jc-between p-ai-center">
                                <h4 class="p-mb-0">Latest Article Requests ({{ countArticleOrders }})</h4>
                                <button pButton pRipple icon="pi pi-arrow-right" label="Ads Manager"
                                    class="p-button p-button-options p-button-sm"
                                    [routerLink]="['/admin/ads-manager']"></button>
                            </div>
                        </ng-template>

                        <ng-container *ngIf="articleOrders.length; else noArticleOrders">
                            <div *ngFor="let order of articleOrders" class="p-grid p-ai-center p-mb-2"
                                style="border-bottom: 1px solid #f0f0f0; padding-bottom: 10px;">
                                <div class="p-col-12 p-md-8">
                                    <p-tag [value]="formatStatus(order.status)"
                                        [severity]="getArticleOrderSeverity(order.status)"></p-tag>
                                    <h4 class="p-mb-0 p-mt-1">{{ order.campaign_name }}</h4>
                                    <p class="small p-mb-0">{{ order.company_name || order.customer_name || ('User #' + order.user_id) }}</p>
                                    <p class="small p-mt-0" style="color:#aaa; font-size:0.78rem;">
                                        {{ order.created_at | date:'medium' }} ·
                                        {{ (order.approved_budget || order.requested_budget) | currency:order.currency }}
                                    </p>
                                </div>
                                <div class="p-col-12 p-md-4">
                                    <button pButton pRipple icon="pi pi-eye" label="Review"
                                        class="p-button p-button-primary btn-block"
                                        [routerLink]="['/admin/ads-manager']"></button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noArticleOrders>
                            <p class="p-text-center p-text-secondary p-p-3">No article requests found.</p>
                        </ng-template>
                    </p-card>

                    <div class="p-mb-3"></div>

                    <p-card class="table-list">
                        <ng-template pTemplate="header">
                            <div class="p-p-3 p-d-flex p-jc-between p-ai-center">
                                <h4 class="p-mb-0">Last Tickets</h4>
                                <button pButton pRipple icon="pi pi-arrow-right" label="All Tickets"
                                    class="p-button p-button-options p-button-sm"
                                    [routerLink]="['/admin/tickets']"></button>
                            </div>
                        </ng-template>

                        <ng-container *ngIf="tickets?.length; else noTickets">
                            <div *ngFor="let ticket of tickets" class="p-grid p-ai-center p-mb-2"
                                style="border-bottom: 1px solid #f0f0f0; padding-bottom: 10px;">
                                <div class="p-col-12 p-md-8">
                                    <div class="p-d-flex p-ai-center p-mb-1">
                                        <p-tag [value]="ticket.status"
                                            [severity]="getTicketStatusSeverity(ticket.status)"
                                            styleClass="p-mr-2"></p-tag>
                                        <p-tag [value]="ticket.priority || 'normal'"
                                            [severity]="getTicketPrioritySeverity(ticket.priority)"></p-tag>
                                    </div>
                                    <h4 class="p-mb-0 p-mt-1">{{ ticket.subject }}</h4>
                                    <p class="small p-mb-0">{{ ticket.name || ticket.email || '-' }}</p>
                                    <p class="small p-mt-0" style="color:#aaa; font-size:0.78rem;">
                                        {{ formatTicketDate(ticket.updated_at) }}
                                    </p>
                                </div>
                                <div class="p-col-12 p-md-4">
                                    <button pButton pRipple icon="pi pi-comments" label="Reply"
                                        class="p-button p-button-primary btn-block"
                                        [routerLink]="['/admin/tickets/detail', ticket.id]"></button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noTickets>
                            <p class="p-text-center p-text-secondary p-p-3">No tickets found.</p>
                        </ng-template>

                    </p-card>





                </div>
            </div>
        </div>
    </div>
</div>
